// single pages
const Unauthorized = () => import(/* webpackChunkName: "common-page" */ '../pages/403.vue')
const notFoundPage = () => import(/* webpackChunkName: "common-page" */ '../pages/NotFound.vue')
const homePage = () => import(/* webpackChunkName: "common-page" */ '../pages/Home.vue')
const loginPage = () => import(/* webpackChunkName: "common-page" */ '../pages/Login.vue')
const registerPage = () => import(/* webpackChunkName: "common-page" */ '../pages/Register.vue')
const forgotPasswordPage = () => import(/* webpackChunkName: "common-page" */ '../pages/ForgotPassword.vue')
const profilePage = () => import(/* webpackChunkName: "common-page" */ '../pages/profile/Profile.vue')
const profileUpdatePage = () => import(/* webpackChunkName: "common-page" */ '../pages/profile/ProfileUpdate.vue')
const profileBankPage = () => import(/* webpackChunkName: "common-page" */ '../pages/profile/ProfileBank.vue')
const dieuKhoanPage = () => import(/* webpackChunkName: "common-page" */ '../pages/profile/Clause.vue')
const VerifyAccountPage = () => import(/* webpackChunkName: "common-page" */ '../pages/profile/VerifyAccount.vue')
const changePassPage = () => import(/* webpackChunkName: "common-page" */ '../pages/profile/ChangePass.vue')

const merchantPage = () => import(/* webpackChunkName: "merchant-page" */ '../pages/merchant/index.vue')
const merchantDetailPage = () => import(/* webpackChunkName: "merchant-page" */ '../pages/merchant/detail.vue')
const merchantCreatePage = () => import(/* webpackChunkName: "merchant-page" */ '../pages/merchant/create.vue')
const merchantUpdatePage = () => import(/* webpackChunkName: "merchant-page" */ '../pages/merchant/update.vue')
const contractPage = () => import(/* webpackChunkName: "contract-page" */ '../pages/contract/index.vue')
const contractDetailPage = () => import(/* webpackChunkName: "contract-page" */ '../pages/contract/detail.vue')

const agentBankPage = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/agentBank/index.vue')
const agentBankDetail = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/agentBank/detail.vue')
const agentBankAdd = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/agentBank/add.vue')
const agentBankEdit = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/agentBank/add.vue')

const transferPage = () => import(/* webpackChunkName: "transfer-device-page" */ '../pages/transferDevices/index.vue')
const transferPageAdd = () => import(/* webpackChunkName: "transfer-device-page" */ '../pages/transferDevices/add.vue')
const transferDetailPage = () => import(/* webpackChunkName: "transfer-device-page" */ '../pages/transferDevices/detail.vue')


const deveicePage = () => import(/* webpackChunkName: "deveicePage-page" */ '../pages/devices/index.vue')
const deveiceDetailPage = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/devices/detail.vue')

const ReportTab = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/partnerPeporting/index.vue')

const OderForm = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/oderForm/index.vue')
const OderFormAdd = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/oderForm/edit.vue')
const OderFormDetail = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/oderForm/detail.vue')

const SalesCombos = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/saleCombo/index.vue')
const SalesCombosAdd = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/saleCombo/add.vue')
const SalesCombosEdit = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/saleCombo/add.vue')
const SalesCombosDetail = () => import(/* webpackChunkName: "agentBank-page" */ '../pages/saleCombo/detail.vue')


import { DOMAIN_TITLE } from '../.env'

export const routes = [
  {
    path: '*',
    component: notFoundPage,
    meta: { title: `${DOMAIN_TITLE} | Page not found` }
  },
  {
    path: '/',
    name: 'index',
    component: homePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | home` }
  },
  {
    path: '/403',
    name: '403',
    component: Unauthorized,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | 403`, layout: 'login' }
  },
  {
    path: '/login',
    name: 'login',
    component: loginPage,
    meta: { title: `${DOMAIN_TITLE} | Đăng nhập`, layout: 'login' }
  },
  {
    path: '/register',
    name: 'register',
    component: registerPage,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | Đăng ký`, layout: 'login' }
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: forgotPasswordPage,
    meta: { isAuth: false, title: `${DOMAIN_TITLE} | Quên mật khẩu`, layout: 'login' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: profilePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thông tin tài khoản` }
  },
  {
    path: '/profile/update',
    name: 'profileUpdate',
    component: profileUpdatePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật thông tin tài khoản` }
  },
  {
    path: '/profile/bank',
    name: 'profileBank',
    component: profileBankPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm tài khoản ngân hàng` }
  },
  {
    path: '/profile/verify-account',
    name: 'VerifyAccount',
    component: VerifyAccountPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Xác thực tài khoản` }
  },
  {
    path: '/profile/dieu-khoan',
    name: 'dieuKhoan',
    component: dieuKhoanPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Điều khoản`, layout: 'login' }
  },
  {
    path: '/profile/change-password',
    name: 'ChangePassword',
    component: changePassPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật mật khẩu` }
  },
  {
    path: '/merchant',
    name: 'Merchant',
    component: merchantPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách Merchant` }
  },
  {
    path: '/merchant/detail/:id',
    name: 'MerchantDetail',
    component: merchantDetailPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết Merchant` }
  },
  {
    path: '/merchant/create',
    name: 'MerchantCreate',
    component: merchantCreatePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới Merchant` }
  },
  {
    path: '/merchant/update/:id',
    name: 'MerchantUpdate',
    component: merchantUpdatePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật Merchant` }
  },
  {
    path: '/contract',
    name: 'Contract',
    component: contractPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách hợp đồng` }
  },
  {
    path: '/contract/detail/:id',
    name: 'ContractDetail',
    component: contractDetailPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết hợp đồng` }
  },
  // agent bank

  {
    path: '/agent-bank',
    name: 'AgentBank',
    component: agentBankPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách tài khoản` }
  },
  {
    path: '/agent-bank/add/',
    name: 'AgentBankAdd',
    component: agentBankAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới tài khoản` }
  },
  {
    path: '/agent-bank/detail/:id',
    name: 'AgentBankDetail',
    component: agentBankDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết tài khoản` }
  },
  {
    path: '/agent-bank/edit/:id',
    name: 'AgentBankEdit',
    component: agentBankEdit,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhạt tài khoản` }
  },
  // transfer device
  {
    path: '/transfer-device',
    name: 'TransferDevice',
    component: transferPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu điều chuyển thiết bị` }
  },
  {
    path: '/transfer-device-add',
    name: 'TransferDeviceAdđ',
    component: transferPageAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới điềuc chuyển thiết bị` }
  },

  {
    path: '/transfer-device-edit/:entryId',
    name: 'TransferDeviceAdđ',
    component: transferPageAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm mới điềuc chuyển thiết bị` }
  },

  {
    path: '/transfer-device/:entryId',
    name: 'TransferDeviceDetaill',
    component: transferDetailPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu điều chuyển thiết bị` }
  },

  // deveice

  {
    path: '/list-device',
    name: 'ListDevice',
    component: deveicePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách thiết bị` }
  },
  {
    path: '/list-device/detail/:id',
    name: 'DetailDevice',
    component: deveiceDetailPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết thiết bị` }
  },

  // report
  {
    path: '/partner-reporting',
    name: 'ReportTab',
    component: ReportTab,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Báo cáo cho đối tác bank` }
  },

  // oder form
  {
    path: '/order-form',
    name: 'OderForm',
    component: OderForm,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Danh sách phiếu đặt hàng` }
  },
   {
    path: '/order-form-detail/:id',
    name: 'OderFormDetail',
    component: OderFormDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Chi tiết sách phiếu đặt hàng` }
  },
   {
    path: '/order-form-add',
    name: 'OderFormAdd',
    component: OderFormAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Thêm phiếu đặt hàng` }
  },
   {
    path: '/order-form-edit/:id',
    name: 'OderFormEdit',
    component: OderFormAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật phiếu đặt hàng` }
  },


   {
    path: '/sales-combos',
    name: 'SalesCombos',
    component: SalesCombos,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Combo bán hàng` }
  },


   {
    path: '/sales-combos-add',
    name: 'SalesCombosAdd',
    component: SalesCombosAdd,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Tạo Combo bán hàng` }
  },

   {
    path: '/sales-combos-edit/:id',
    name: 'SalesCombosEdit',
    component: SalesCombosEdit,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật Combo bán hàng` }
  },
   {
    path: '/sales-combos-detail/:id',
    name: 'SalesCombosEdit',
    component: SalesCombosDetail,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Cập nhật Combo bán hàng` }
  },


]
